import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider, extendTheme, withDefaultColorScheme } from "@chakra-ui/react";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";
import store from "./Redux/store";
import ErrorBoundary from "./ErrorBoundary";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { QueryClient, QueryClientProvider } from "react-query";

const theme = extendTheme(
	withDefaultColorScheme({
		colorScheme: "brand",
		components: ["Switch"],
	}),
	{
		components: {
			Progress: {
				baseStyle: {
					filledTrack: {
						borderRadius: "0px",
						bg: "#fff",
					},
				},
			},
		},
		styles: {
			global: {
				body: {
					backgroundColor: "#fff",
					fontFamily: "Poppins",
				},
				"form label": {
					fontFamily: "Montserrat",
					fontWeight: "500 !important",
					letterSpacing: "0.5px",
					color: "rgba(30, 30, 30, 0.7)",
				},
				".css-i13umd": {
					alignItems: "center",
				},
				".css-7roig": {
					height: "12px !important",
					width: "12px !important",
					marginLeft: "4px",
				},
				".css-3b6enb": {
					background: "#1CBAA7 !important"
				},
				".css-7roig[aria-checked=true], .css-7roig[data-checked]": {
					height: "12px",
					width: "12px",
					marginLeft: 0,
				},
				"footer button": {
					textTransform: "uppercase !important",
					fontWeight: "500 !important",
					letterSpacing: "1px",
				},
			},
			"form button": {
				textTransform: "uppercase !important",
			},
		},
		colors: {
			brand: {
				100: "#eee",
				500: "#1CBAA7",
				700: "rgba(30, 30, 30, 0.8)",
				900: "#1a202c",
			},
			text: {
				100: "#eee",
				500: "#093653",
			},
		},
		breakpoints: {
			sm: "320px",
			md: "768px",
			lg: "1024px",
			xl: "1440px",
			"2xl": "2560px",
		},
	}
);

const queryClient = new QueryClient({ defaultOptions: { queries: { cacheTime: 0 } } });
const persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	// <React.StrictMode>
	<Provider store={store}>
		<PersistGate persistor={persistor}>
			<CookiesProvider>
				<BrowserRouter>
					<ChakraProvider theme={theme}>
						<QueryClientProvider client={queryClient}>
							<ErrorBoundary>
								<App />
								<ToastContainer
									bodyClassName='custom-toast'
									toastClassName={"toast-glass-effect"}
									theme='colored'
									position='top-center'
									autoClose={5000}
								/>
							</ErrorBoundary>
						</QueryClientProvider>
					</ChakraProvider>
				</BrowserRouter>
			</CookiesProvider>
		</PersistGate>
	</Provider>
	//  </React.StrictMode>
);
